import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import './assets/main.css';

import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import VueCameraLib from 'vue-camera-lib'
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import VueDeviceDetect from '@basitcodeenv/vue3-device-detect'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'leaflet/dist/leaflet.css';
import axios from "axios";
import LocalStorageService from "./services/LocalStorageService";
import JsonExcel from "vue-json-excel3";

import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';

import VueImageZoomer from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';

const app = createApp(App);
app.use(router);
app.use(VueCameraLib)
app.use(LoadingPlugin);
app.use(VueDeviceDetect);
app.use(VueSweetalert2);
app.use(VueImageZoomer);
app.component("downloadExcel", JsonExcel);
app.component('DatePicker', VueDatepickerUi)

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// axios.defaults.withCredentials = true;
// axios.defaults.xsrfCookieName = 'csrftoken';
// axios.defaults.xsrfHeaderName = 'X-CSRFToken';
// axios.defaults.headers.common['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = '*';
axios.interceptors.request.use((config) => {

    const token = LocalStorageService.isAuth();
    if (token && !config.url.includes('api.ipify.org')) {
        config.headers["Authorization"] = "Bearer "+LocalStorageService.getAccessToken();
    }

    // Modify the request config here
    // config.headers.ContentType = 'application/json'
    // config.headers. = 'application/json'
    //
    // config.headers = {
    //     'Content-Type': 'application/json',
    //     'Access-Control-Allow-Origin': '*',
    //     'Access-Control-Allow-Methods': '*',
    //     'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    //     'Access-Control-Allow-Credentials': 'true',
    // }

    // header('Access-Control-Allow-Origin: *');
    // header('Access-Control-Allow-Methods: GET, PUT, POST, DELETE, OPTIONS, post, get');
    // header("Access-Control-Max-Age", "3600");
    // header('Access-Control-Allow-Headers: Origin, Content-Type, X-Auth-Token');
    // header("Access-Control-Allow-Credentials", "true");

    return config
})

// Response interceptor
axios.interceptors.response.use((response) => {
    // Handle the response here
    return response
}, (error) => {
    // Handle errors here
    console.error(error)
    return Promise.reject(error)
})

app.config.globalProperties.$localStorageService1 = LocalStorageService.getService();
app.provide('$localStorageService', LocalStorageService.getService())
app.provide('$axios', axios);
app.provide('bootstrap', bootstrap);
app.mount('#app');